<template>
  <div>
    <div class="container-fluid mt-3">
      <div class="row">
        <!-- <button @click="playsound()" id="audioplay">playsound</button> -->
        <div class="col-md-4" v-for="order in orderData" :key="order.order_no">
          <div class="card">
            <!-- Card image -->
            <!-- <img class="card-img-top" src="img/theme/img-1-1000x900.jpg" alt="Image placeholder"> -->
            <!-- Card body -->
            <div class="card-body">
              <h5 class="h3 card-title mb-0">Order-Id: {{order.order_no}}</h5>
              <small class="mb-0 d-block" v-if="order.order_items[0]">Delivery time: {{format_datetime(order.delivery_datetime)}}</small>
              <small class="mb-2 d-block">Customer name: {{order.user_oid.user_name}}</small>
              <div class="bg-lightest p-2 mb-2 rounded shadow-sm border" v-for="product in order.order_items" :key="product._id">
                <p class="mb-1 font-weight-500" v-if="product.products">{{product.product_name}}</p>
                <p class="mb-1 small" v-if="product.shape"><span class="font-weight-600">Shape:</span> {{product.shape}}</p>
                <p class="mb-1 small" v-if="product.size"><span class="font-weight-600">Size:</span> {{product.size}}</p>
                <p class="mb-1 small" v-if="product.message"><span class="font-weight-600">Message on item:</span> {{product.message}}</p> 
                <p class="mb-1 small" v-if="product.product_qty"><span class="font-weight-600">Item Unit:</span> {{product.quantity}}{{product.unit}} x {{product.product_qty}}</p>
                <img :src="product.order_image" v-if="product.order_image" class="img-fluid avatar avatar-lg">
              </div>
              <span class="btn btn-warning mt-3"  v-if="pagepermission.update" @click="readyorder(order)">Order Ready</span>
              <span class="float-right mt-4" v-if="order.store_id"><i class="fas fa-map-marker"></i> {{getstore_name(order.store_id)}}</span>
            </div>
          </div>
        </div>
        <!-- no result found -->
        <div class="col-md-12 justify-content-center" id="noresult" v-if="datanotfound">
          <div class="col-md-3 mx-auto mt-4 text-center">
              <img src="/img/theme/no-result.png" class="img-fluid">
              <p class="mt-4">No orders received.</p>
          </div>
        </div>
        <!-- shimmer starts here -->
        <div class="col-md-12" v-if="orderData.length==0 && !datanotfound">
          <div class="row justify-content-center">
            <div class="col-lg-12 mt-3">
                <div class="card border-0 shadow">
                   <div class="card-body pt-2 pb-1">
                        <div class="row">
                            <div class="col-md-3 col-3 mt-1 mb-1">
                                <span class="circle-shimmer shine"></span>
                            </div>
                            <div class="col-md-9 col-9 mt-1 mb-1">
                                <div class="div-shimmer w-100 mt-0 pr-4">
                                  <span class="line-shimmer w-100 shine"></span>
                                  <span class="line-shimmer w-100 shine"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card border-0 shadow">
                   <div class="card-body pt-2 pb-1">
                        <div class="row">
                            <div class="col-md-3 col-3 mt-1 mb-1">
                                <span class="circle-shimmer shine"></span>
                            </div>
                            <div class="col-md-9 col-9 mt-1 mb-1">
                                <div class="div-shimmer w-100 mt-0 pr-4">
                                  <span class="line-shimmer w-100 shine"></span>
                                  <span class="line-shimmer w-100 shine"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card border-0 shadow">
                   <div class="card-body pt-2 pb-1">
                        <div class="row">
                            <div class="col-md-3 col-3 mt-1 mb-1">
                                <span class="circle-shimmer shine"></span>
                            </div>
                            <div class="col-md-9 col-9 mt-1 mb-1">
                                <div class="div-shimmer w-100 mt-0 pr-4">
                                  <span class="line-shimmer w-100 shine"></span>
                                  <span class="line-shimmer w-100 shine"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="card border-0 shadow">
                   <div class="card-body pt-2 pb-1">
                        <div class="row">
                            <div class="col-md-3 col-3 mt-1 mb-1">
                                <span class="circle-shimmer shine"></span>
                            </div>
                            <div class="col-md-9 col-9 mt-1 mb-1">
                                <div class="div-shimmer w-100 mt-0 pr-4">
                                  <span class="line-shimmer w-100 shine"></span>
                                  <span class="line-shimmer w-100 shine"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <!-- shimmer ends here -->
      </div>
      <div class="row mb-5 d-none">
        <div class="col">
          <div class="card shadow" :class="''">
            <div class="card-header border-0" :class="''">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="''">
                    Preparing Orders
                  </h3>
                </div>
                <div class="col text-right">
                  <base-input class="mb-0 search-input mr-2" input-group-classes="input-group-merge" placeholder="Search order" v-model="search_term" @keyup.enter="searchOrder()">
                      <template slot="append"><a href="#"><i class="fas fa-search" @click="searchOrder()"></i></a></template>
                  </base-input>
                  <select class="form-control d-inline w-auto mr-2" v-model="status" @change="getorderbystatus()">
                    <option value="">Status</option>
                    <option value="processing">Processing</option>
                    <option value="shipped">Shipped</option>
                    <option value="delivered">Delivered</option>
                    <option value="cancelled">Cancelled</option>
                  </select>
                  <base-button type="primary" @click="cleardata()">Clear</base-button>
                </div>
              </div>
            </div>
            <div class="table-responsive" style="display: block;">
              <base-table class="table align-items-center table-flush" :class="''" :thead-classes="'thead-light'" tbody-classes="list" :data="orderData">
                <template slot="columns">
                  <th>Customer</th>
                  <th>Order ID</th>
                  <th>Product/s</th>
                  <th>Amount</th>
                  <!-- <th>Payment Mode</th> -->
                  <th>Order Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </template>
                <template slot-scope="{row,index}">
                    <td class="budget px-3">
                      <span class="mb-0"><span class="mr-3">{{ (offset*30)+(index+1) }}.</span>{{row.user_oid.user_name}}</span>
                    </td>
                    <td class="budget px-2" >
                      <span>#{{row.order_no}}</span>
                    </td>
                    <!-- <td class="budget">
                      
                      <img alt="Image placeholder" class="rounded" src="img/theme/team-1.png" width="100">
                    </td> -->
                    <td class="budget" >
                      <span class="pr-1" v-for="product in row.products" :key="product._id" style="white-space: normal;">{{product.item_name}},</span>
                    </td>
                    <td class="budget">
                      <span class="d-block">₹ {{row.amount/100}}</span>
                      <span>({{row.payment_mode}})</span>
                    </td>
                    <td class="budget px-0" style="white-space: normal;">
                      <span>{{format_datetime(row.order_date)}}</span>
                    </td>
                    <td class="budget pr-0">
                      <span v-if="row.order_status=='processing'" class="badge badge-dot badge-info">
                        <i class="bg-info"></i>
                        <span class="status">{{row.order_status}}</span>
                      </span>
                      <span v-if="row.order_status=='shipped'" class="badge badge-dot badge-primary">
                        <i class="bg-primary"></i>
                        <span class="status">{{row.order_status}}</span>
                      </span>
                      <span v-if="row.order_status=='delivered'" class="badge badge-dot badge-success">
                        <i class="bg-success"></i>
                        <span class="status">{{row.order_status}}</span>
                      </span>
                      <span v-if="row.order_status=='cancelled'" class="badge badge-dot badge-danger">
                        <i class="bg-danger"></i>
                        <span class="status">{{row.order_status}}</span>
                      </span>
                    </td>
                    <td class="text-right">
                      <base-button type="primary" size="sm" @click="opencategory(row)">Update</base-button>
                      <a class="btn btn-primary btn-sm" :href="'#/orders/orderdetails/'+row._id" icon="fa fa-info">View</a>
                      <base-button type="danger" size="sm" @click="deleteorder(row)" ><i class="fas fa-trash"></i></base-button>
                    </td>
                </template>
              </base-table>
              <!-- <div class="d-block mb-5 mt-2">
                <base-button
                  type="success"
                  class="float-center m-auto d-block"
                   v-if="loadmorefound" 
                   @click="loadmore()"
                >
                  <span>Load More</span>
                </base-button>
              </div> -->
              <!-- no result found -->
              <div class="card-footer justify-content-center" id="noresult" v-if="datanotfound">
                <div class="col-md-3 mx-auto mt-4 text-center">
                    <img src="/img/theme/no-result.png" class="img-fluid">
                    <p class="mt-4">No orders received.</p>
                    <base-button type="primary" @click="cleardata()" outline>Fetch all</base-button>
                </div>
              </div>
              <!-- shimmer starts here -->
              <div class="col-md-12" v-if="orderData.length==0 && !datanotfound">
                <div class="row justify-content-center">
                  <div class="col-lg-12 mt-3">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <!-- shimmer ends here -->
            </div>
            <div class="card-footer d-flex justify-content-end" v-if="!datanotfound">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <li class="page-item d-flex mr-2">
                      <p class="mb-0 px-1 mt-1">
                        Page
                      </p>
                      <input
                        id="page_no"
                        size="4"
                        class="mx-1 p-1 text-center"
                        style="border: 1px solid #e9ecff;border-radius: 5px !important;background-color: #e9ecff;width: 4em;"
                        type="number"
                        name="page_no"
                      >
                      <base-button
                        block
                        type="primary"
                        class="px-3 mx-1"
                        title="GO"
                        size="sm"
                        @click="gotopage()"
                      >
                        GO
                      </base-button>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link"
                        @click="previouspage()"
                      > <span aria-hidden="true"><i
                        aria-hidden="true"
                        class="fa fa-angle-left"
                      /></span> </a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link"
                        @click="nextpage()"
                      > <span aria-hidden="true"><i
                        aria-hidden="true"
                        class="fa fa-angle-right"
                      /></span> </a>
                    </li>
                  </ul>
                </nav> 
              </div>
          </div>
        </div>
      </div>
      <modal :show.sync="editcategory" size="lg">
        <p
          id="modal-title-default"
          slot="header"
          class="modal-title"
        >
          <span>update order</span>
        </p>  
        <template>
          <form @submit.prevent>
            <div class="row">
              <div class="col-lg-6">
                  <base-input label="Order ID" placeholder="Order Id" input-classes="" v-model="ordermodal.order_no" readonly />
              </div>
              <div class="col-lg-6">
                   <label class="form-control-label">Order Status</label>
                    <select  aria-describedby="addon-right addon-left" class="form-control" v-model="ordermodal.order_status" autocomplete="off">
                        <option>processing</option>
                        <option>shipped</option>
                        <option>delivered</option>
                        <option>cancelled</option>
                   </select>
               </div>
            </div>
          </form>
        </template>
        <template slot="footer">
          <base-button
            @click="updateorder()"
            type="success"
            class="float-center"
            id="updateproductbtn"
          >
            <span>Update Order</span>
          </base-button>
          <base-button
            type="link"
            class="ml-auto"
            @click="editcategory = false">
            <span>Close</span>
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Components
  import BaseProgress from '@/components/BaseProgress';
  // import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
  import moment from 'moment';
  import VueSwal from 'vue-swal';
  import axios from "axios";
  // Lists
  // import ActivityFeed from './ActivityFeed';
  // import TaskList from './TaskList';
  // import UserList from './UserList';
  // import ProgressTrackList from './ProgressTrackList';

  // // Tables
  // import LightTable from './LightTable';
  // import SocialTrafficTable from './SocialTrafficTable';
  // import PageVisitsTable from './PageVisitsTable';

  export default {
    components: {
      // ActivityFeed,
      // LineChart,
      // BarChart,
      // BaseProgress,
      // StatsCard,
      // TaskList,
      // PageVisitsTable,
      // SocialTrafficTable,
      // LightTable,
      // UserList,
      // ProgressTrackList
      DropzoneFileUpload,
    },
    data() {
      return {
        inputs: {
          file: []
        },
        interval:null,
        status:'',
        orderData:[],
        prepairingData:[],
        datanotfound:false,
        store_name:'',
        ordercount:0,
        variationData:[],
        search_term:'',
        pagepermission:{},
        subcategoryproductData:[],
        storeData:[],
        galleryarr:[],
        banneruploadPercentage:0,
        offset:0,
        store:'',
        loadmorefound:1,
        editcategory:false,
        ordermodal:{ order_no:'',order_status:''},
        editproduct:false,
        uploadPercentage:0,
        item_price:[{item_id : '',item_name : '',unit : '',quantity : 0,availability_now : 0,marked_price : 0,price : 0,is_featured : false,sequenced_at : 0,status: "approved",visibility : "visible"}],
        
        auth : {
          headers: { 'Content-Type':'application/x-www-form-urlencoded',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
        auth1 : { headers: { 'Content-Type':'application/json',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
      }
    },
    mounted () {
      
      this.pagepermission=JSON.parse(localStorage.getItem(this.$router.currentRoute.path));
      console.log(this.pagepermission);
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_store',{ "details" :{}},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.storeData=response.data.details;
            if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
               this.store_name=this.getstore_name(localStorage.getItem('store_id'));
            }
            let details={ "details" :{"type":"order","order_status":"preparing"},"offset":"0"};
            if(this.store_name){
              details.details.city=this.store_name;
            }
            if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                      details.details.store_id=localStorage.getItem('store_id');
            }
            axios
            .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
            .then(response => {
              console.log(response);
              if(response.data.details){
              this.orderData=response.data.details;
              console.log(this.orderData);
              this.prepairingData=_.map(this.orderData, order => (order._id));
              this.datanotfound=false;
              }else{
                  this.orderData=[];
                  this.datanotfound=true;
              }
                  
            })
            axios
              .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
              .then(response => {
                console.log(response);
                if(response.data.details.length>0){
                this.ordercount=response.data.details[0].COUNT;
                }
                    
              })
        }
            
      })
      const querystring = require('querystring');
      

      


    },
    created () {
      // console.log("hi"+localStorage.getItem('bell_notification'));
      // if(localStorage.getItem('bell_notification')!='0'){
      this.currentorderData()
      // }
    },
    beforeDestroy: function(){
     clearInterval(this.interval);
    },
    methods: {
         currentorderData () {
            let ref=this;
            this.interval =setInterval(function(){ 
                      console.log("Api call"); 
                      // var audio = new Audio('https://bakenetoweb.s3.ap-south-1.amazonaws.com/notification.wav') 
                      //   audio.play();
                         ref.checkData();
                         clearInterval(this.interval);
                  }, 5000);
          },
          checkData: function () {
            let ref=this;
            console.log("calling");
                  ref.store_name=ref.getstore_name(localStorage.getItem('store_id'));
                  let details={ "details" :{"type":"order","order_status":"preparing"},"offset":"0","count":ref.ordercount,"order_ids":ref.prepairingData};
                  if(ref.store_name){
                    details.details.city=ref.store_name;
                  }
                  if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                      details.details.store_id=localStorage.getItem('store_id');
                  }
                  axios
                  .post(process.env.VUE_APP_API_ENDPOINT+'check_order_count',details,ref.auth1)
                  .then(response => {
                    console.log(response);
                    if(response.data.details){
                      if(response.data.details.neworder){
                      var audio = new Audio('https://bakenetoweb.s3.ap-south-1.amazonaws.com/notification.wav') 
                        audio.play();
                        swal({
                            title:'New order received!',
                            text: 'A new order has been created.',
                            icon:'success',
                           }).then((result) => {
                            console.log(result)
                             if (result) {
                              // window.location.reload()
                            }
                          })
                        }
                        if(response.data.details.cancelled_status){
                          var audio = new Audio('https://bakenetoweb.s3.ap-south-1.amazonaws.com/notification.wav') 
                          audio.play();
                          swal({
                            title:'order cancelled!',
                            text: 'A order has been cancelled.',
                            icon:'info',
                          }).then((result) => {
                            console.log(result)
                             if (result) {
                              // window.location.reload()
                            }
                          })
                        }
                      // var audio = new Audio(require('https://bakenetoweb.s3.ap-south-1.amazonaws.com/notification.wav')) 
                      // // var audio = new Audio('file.mp3'),
                      // audio.play();
                      axios
                        .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,ref.auth1)
                        .then(response => {
                          console.log(response);
                          if(response.data.details){
                          ref.orderData=response.data.details;
                          ref.prepairingData=_.map(ref.orderData, order => (order._id));
                          ref.datanotfound=false;
                          }else{
                              ref.datanotfound=true;
                              ref.orderData=[];
                               ref.prepairingData=[];
                          }
                              
                        })
                        axios
                          .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,ref.auth1)
                          .then(response => {
                            console.log(response);
                            if(response.data.details.length>0){
                            ref.ordercount=response.data.details[0].COUNT;
                            }
                                
                          })
                       
                    }
                        
                  })
            // $.get('/api/data', function (response) {
            //   this.items = response.items;
            // }.bind(this));
          },
          getalldata(){
              this.store_name=this.getstore_name(localStorage.getItem('store_id'));
              let details={ "details" :{"type":"order","order_status":"processing"},"offset":"0"};
              if(this.store_name){
                details.details.city=this.store_name;
              }
              if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                      details.details.store_id=localStorage.getItem('store_id');
              }
              axios
                .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
                .then(response => {
                  console.log(response);
                  if(response.data.details){
                  this.orderData=response.data.details;
                  this.datanotfound=false;
                  }else{
                      this.datanotfound=true;
                      this.orderData=[];
                  }
                      
                })

          },
          getstore_name(val){

              const search = this.storeData.find(element => element.store_id === val);
              if(search){
                return search.store_name;
              }
              
          },
          hadleimage: function(event,type) {
              // Reference to the DOM input element
              this.uploadPercentage =0;
              var input = event.target;
              // Ensure that you have a file before attempting to read it
              if(input.files[0].size < 5000000){

              const fd= new FormData();
              fd.append('image',input.files[0],input.files[0].name);
              axios
              .post(process.env.VUE_APP_API_ENDPOINT+'image-upload',fd,{ headers: {'Content-Type': 'multipart/form-data'},onUploadProgress: function( progressEvent ) { this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) ); console.log(this.uploadPercentage)}.bind(this)})
              .then(response => {
                console.log(response);
                if(type=='thumbnail'){
                  this.productmodal.item_thumbnail=response.data.imageUrl;
                  console.log(this.productmodal.item_thumbnail);
                }else if(type=='main_img'){
                  this.productmodal.item_main_img=response.data.imageUrl;
                  console.log(this.productmodal.item_main_img);
                }else if(type=='secondary_img'){
                  this.productmodal.item_secondary_img=response.data.imageUrl;
                  console.log(this.productmodal.item_secondary_img);
                }
                  
              })

              }else{

              swal({
                title:'File too large!',
                text: 'Your file is larger than 5 MB. Please upload images which are less than 5 MB.',
                icon:'warning',
               }).then((result) => {
                 
              })

            }

        },
        async bannerupload(event,type,uploatype) {
              // Reference to the DOM input element
                //console.log(event);
                // document.getElementById("editassignmentbtn").classList.add('d-none');
                // document.getElementById("editaddassignmentinvalid").classList.remove('d-none');
               this.banneruploadPercentage =0;
                if(uploatype=='file1'){
                  for( var i = 0; i < this.$refs.file1.files.length; i++ ){
                      let file = this.$refs.file1.files[i];
                      //console.log(file);
                      await this.upload(file,type);
                      
                      
                  }
                }
                if(uploatype=='file3'){
                  for( var i = 0; i < this.$refs.file3.files.length; i++ ){
                      let file = this.$refs.file3.files[i];
                      //console.log(file);
                      await this.upload(file,type);
                      
                      
                  }
                }

        },
        upload(file,type){
          //console.log(file);
          let fd = new FormData();
          fd.append('image',file,file.name);
          axios.post(process.env.VUE_APP_API_ENDPOINT+'image-upload',fd,{ headers: {'Content-Type': 'multipart/form-data'},onUploadProgress: function( progressEvent ) { this.banneruploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) ); console.log(this.banneruploadPercentage)}.bind(this)}).then(response => {
            //console.log(response);
            this.galleryarr.push(response.data.imageUrl);
            //console.log(this.imagearr);
            // if(type=='add'){
            //   this.categorymodal.banner_primary=this.imagearr;
            //   //console.log(this.assignmentmodel.assignment_file);
            // }
            // else{
            //   this.categorymodal.banner_secondary=this.imagearr;
            // }
            //console.log();
         })

        },
      opencategory(row){
          this.editcategory=true;
          this.ordermodal=row;

        },
      getorderbystatus(){
        let details={ "details" :{"type":"order","order_status":this.status},"offset":"0"};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                      details.details.store_id=localStorage.getItem('store_id');
            }
       if(this.status) {
         axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.details){
          this.orderData=response.data.details;
           this.datanotfound=false;
          }else{
              this.orderData=[];
              this.datanotfound=true;
          }
              
        })
      }else{

        axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.details){
          this.orderData=response.data.details;
          this.datanotfound=false;
          }else{
              this.datanotfound=true;
              this.orderData=[];
          }
              
        })

      }

    },
    searchOrder(){
      let details={ "search_term" :this.search_term};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                  details.store_id=localStorage.getItem('store_id');
        }
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'search_order',details,this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.orderData=response.data.details;
        this.datanotfound=false;
        }else{
          this.orderData=[];
          this.datanotfound=true;
        }
            
       })
      },
      cleardata(){
        this.search_term='';
        this.status='';
        let details={ "details" :{"type":"order"},"offset":"0"};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                  details.details.store_id=localStorage.getItem('store_id');
        }
         axios
           .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1).then(response => {
            console.log(response);
            if(response.data.details){
            this.orderData=response.data.details;
            this.datanotfound=false;
            }else{
              this.orderData=[];
              this.datanotfound=true;
            }
            
       })
          
      },
      updateorder() {
        console.log(this.ordermodal);
           const querystring = require('querystring');
           axios.post(process.env.VUE_APP_API_ENDPOINT+'update_order',querystring.stringify({ order_id : this.ordermodal.order_id,order_status:this.ordermodal.status}),this.auth)
          .then(response => {
            console.log(response);
            let title='';
            let img='';
            let datetime= new Date();
            datetime=datetime.toString();
            let order_status_img='';
            if(this.ordermodal.order_status=='processing'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143645089922%20%281%29.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615449806078orderstatus_placed.png';
            }
            if(this.ordermodal.order_status=='shipped'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143644133501.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615626164310orderstatus_shipped.png';
            }
            if(this.ordermodal.order_status=='delivered'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143645588443.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615626069552orderstatus_delivered.png';
            }
            if(this.ordermodal.order_status=='cancelled'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143646488074%20%281%29.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615627255989orderstatus_cancelled.png';
            }
            //mail template
            let order_status=this.ordermodal.order_status;
            let name=this.ordermodal.user_oid.user_name;
            let order_no=this.ordermodal.order_no;
            let address=this.ordermodal.address;
            let city=this.ordermodal.city;
            let pincode=this.ordermodal.pincode;
            let state=this.ordermodal.state;  
            let orderdetails=this.ordermodal.order_items;
            let amount=this.ordermodal.amount/100;

            let message='<div style="width: 100%; height: 100%; margin: 10px auto; padding: 0; background-color: #f1f2f3; font-family: Roboto-Regular, Arial, Tahoma, Verdana, sans-serif; font-weight: 300; font-size: 13px; text-align: center;"> <div style="background: #4caf50; max-width: 680px; padding-top: 15px; margin: 0 auto; height: 45px;"> <div style="width: 50%; text-align: left; float: left; padding-left: 16px;"> <a style="text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="30" src="https://elfreshapp.s3.ap-south-1.amazonaws.com/1614757182990razorpay.png" alt="Elfresh.in" style="border: none;" class="CToWUd" /> </a> </div> <div style="text-align: right; color: rgba(255, 255, 255, 0.8); margin-top: 6px; font-family: Roboto-Medium, sans-serif; font-size: 14px; font-style: normal; font-stretch: normal; padding-right: 16px;"> Order '+order_status+' </div> </div> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 10px; background-color: #f1f2f3;"> <tbody> <tr> <td> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="display: block; margin: 0 auto; clear: both; padding: 0px 40px;"> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="color: #212121; display: block; margin: 0 auto; clear: both; padding: 3px 0 0 0;"> <table width="100%" cellspacing="0" cellpadding="0"> <tbody> <tr> <td valign="top" align="left" style="float: none; background-color: transparent; padding: 0; text-align: center; vertical-align: middle;"> <img border="0" src="'+order_status_img+'" alt="Order Jouney" style="border: none; width: 80%;" class="CToWUd" /> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 30px 0 0 0; max-width: 600px; background: #ffffff;" border="0"> <tbody> <tr> <td> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="table-layout: fixed; border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 260px; border: none; margin-bottom: 24px; margin-right: 30px;" > <tbody> <tr> <td valign="top" align="left" style="border-right: 1px solid #f4f4f4; padding-right: 10px;"> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121;margin-bottom: 5px;">Hi '+name+',</p> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121;">Order successfully '+order_status+'.</p> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;"></p> <p style="padding: 0; margin: 0; font-size: 12px; line-height: 20px; font-family: Roboto, sans-serif; font-weight: 400; padding-bottom: 12px;"> We are pleased to '+order_status+' your order no '+order_no+'. <br /> Thank you for shopping with El Fresh! </p> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 220px; border: none; margin-bottom: 24px;" > <tbody> <tr> <td valign="top" align="left"> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;">Delivery Address</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px; padding-right: 35px; color: #212121;"></p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+name+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+address+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+city+' - '+pincode+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+state+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">Mob. '+pincode+'</p> <p></p> </td> </tr> </tbody> </table> <table width="600" border="0" cellpadding="0" cellspacing="0" align="left"> <tbody> <tr> <td valign="top" align="left"> <p style=" font-family: Arial; font-size: 12px; text-align: left; color: #212121; padding-top: 0px; padding-bottom: 0px; line-height: 19px; margin-top: 0; margin-bottom: 0; " > <strong>Ordered Products</strong> </p> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="width: 100%; max-width: 600px; border-bottom: 1px solid #f0f0f0; background: #ffffff;" border="0"> <tbody> <tr></tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="color: #212121; display: block; margin: 0 auto; clear: both; padding: 30px 0 24px 0;"> <table width="100%" cellspacing="0" cellpadding="0"> <tbody>';
            for (let i = 0; i < orderdetails.length; i++) {  

              message +='<tr> <td width="120" valign="top" align="left"> <a style="color: #027cd8; text-decoration: none; outline: none; color: #ffffff; font-size: 13px; display: block; width: 100px;" href="#" target="_blank" > <img border="0" src="'+orderdetails[i].products.item_thumbnail+'" alt="'+orderdetails[i].products.item_name+'" style="border: none; margin-left: auto; margin-right: auto; display: block; width: fit-content;max-width: 100px;" class="CToWUd" /> </a> </td> <td valign="top" align="left"> <p style="margin-bottom: 13px;"> <a href="#" style=" font-family: Roboto, sans-serif; font-size: 14px; font-weight: normal; font-style: normal; font-stretch: normal; line-height: 1.25; color: #2175ff; text-decoration: none; " target="_blank" > '+orderdetails[i].item_price_type.quantity+' '+orderdetails[i].item_price_type.unit+' </a> <sup></sup> <br /> </p> <p style=" font-family: Roboto, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; line-height: 1.5; font-stretch: normal; color: #212121; margin: 0px 0px; " > '+orderdetails[i].products.item_name+' </p> <p style="font-family: Roboto-Medium, sans-serif; font-style: normal; line-height: 1.5; font-stretch: normal; color: #212121; margin: 5px 0px;"> <span style="padding-right: 10px;">₹'+orderdetails[i].item_price_type.price+'</span> <span style=" font-family: Roboto-Medium, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; line-height: 1.5; font-stretch: normal; color: #878787; margin: 0px 0px; border: 1px solid #dfdfdf; display: inline; border-radius: 3px; padding: 3px 10px; " > Qty: '+orderdetails[i].product_qty+'</span></p></td></tr>';

            }

            message+='</tbody> </table> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 30px 0 0 0; max-width: 600px; background: #ffffff;" border="0"> <tbody> <tr> <td> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 220px; border: none; margin-bottom: 24px;" > <tbody> <tr> <td valign="top" align="left"> <p style="padding: 0; margin: 0; font-size: 14px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;">Payment Details</p> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td style="padding: 0px;"> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; font-weight: 400; color: #212121;"> Amount Payable <span style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto-Medium, sans-serif; color: #212121; padding-left: 10px;">₹'+amount+'</span> </p> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <br /> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; margin-top: 24px;"> <tbody> <tr> <td align="left" valign="top" style="color: #2c2c2c; display: block; line-height: 20px; font-weight: 300; margin: 0 auto; clear: both; background-color: transparent;"> <table class="m_-5815304530935329508body-wrapper"> <tbody> <tr> <td style="width: 75%; text-align: left;"> <a style="color: #027cd8; text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="50" src="https://elfreshapp.s3.ap-south-1.amazonaws.com/1614757182990razorpay.png" alt="Flipkart.com" style="border: none;" class="CToWUd" /> </a> </td> <td style="width: 8%; text-align: left;"> <a style="text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="24" src="https://ci6.googleusercontent.com/proxy/3QE9kvI6a_sNZY1yz9h1e9UTtBEe6bvUPfsokYVFhigLrmrCJxcv1_CZk0b5cJWyTHa1prcEfHSGUl1QMcg36fPaTs0H7MVxDk0pgC8ujoEedjfg26Rdff_eNArN9_s=s0-d-e1-ft#http://img6a.flixcart.com/www/promos/new/20160910-183744-google-play-min.png" alt="Flipkart.com" style="border: none;" class="CToWUd" /> </a> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <img style="width: 1px; height: 1px;" src="https://ci5.googleusercontent.com/proxy/of2aZ7knL5CxEa8F8aZ46X08Ng9atQwmyw1vsqbopYypXklKaz-rQnALOE9fy0bP3GYh1nygy9zPHpIHAZYdsbAle2ql9EyZfx6yMA4IltKvDStbNs0P6B7YFcAsEGjoLZb3Yl7Js4v-HW4bUkBRvFBktvO-Q9CKdmzv_AoPGYfxPaRnXn405GX1gMVhNxg7_OubIWrdkr0Ct7OjbR8vcpnkk9spzA_ULIk7OOuYvNov7Jp9XHwLsHqM7BYcUD4HADPCAfPHxPqDj1oYZG4IOl2sR6yrsY9PihpwZzDe3jhQ-mIVlp5awBwLi_KO99hOt0imjghl9QNL=s0-d-e1-ft#http://l.flipkart.com/t/open/H4sIAAAAAAAAAB2MzQ7CIBCE32XPpWEV-enJi0efwSwULLFNGwKmxvjurt5m5vsyb3jCgB0EGCAulGfoIHPW-mjiwaFwyqBQzgVhk5LCS-nRhpNPLrI6srpQKy_qC01tRsTz_XfTh3VhHioLJVKY1lb_fefhchW17DeyRkqdDLkxeobEKM15e1Cp8PkCqJhVxpoAAAA=" class="CToWUd" /> <div class="yj6qo"></div> <div class="adL"></div> </div>';

            axios.post(process.env.VUE_APP_API_ENDPOINT+'create_notification',querystring.stringify({user_oid:this.ordermodal.user_oid._id,notif_todo : 'openOrderDetails',notif_title:'You order has been '+this.ordermodal.order_status,notif_message:'View order details',notif_img:img,notif_link:this.ordermodal._id,created_by:localStorage.getItem('_id'),notif_date:datetime}),this.auth)
              .then(response => {
            
              // console.log(response);
                        axios
                           .post(process.env.VUE_APP_API_ENDPOINT+'push_notification',querystring.stringify({ fcm_token:this.ordermodal.user_oid.user_fcm,notif_todo:'openOrderDetails',notif_title:'You order has been '+this.ordermodal.order_status,notif_message:'View order details',notif_img:img,notif_thumbnail:img,notif_link:this.ordermodal._id,sender_id:'Admin',notification_id:response.data.details.notification_id}),this.auth)
                          .then(response => {

                            // console.log(response);
                            
                            
                          })
              
              
            })
            axios
             .post(process.env.VUE_APP_API_ENDPOINT+'send_mail',querystring.stringify({ email:this.ordermodal.user_oid.user_email,user_name:this.ordermodal.user_oid.user_name,subject_body:'You order status updated',type:'orderupdate',html_body:message}),this.auth)
            .then(response => {

              // console.log(response);
              
              
            })
            if(this.ordermodal.order_status=='delivered'){
             console.log(this.ordermodal);
             if(this.ordermodal.user_oid.redemption_done=='no' && this.ordermodal.user_oid.refer_by_code!=undefined){
               axios
                  .post(process.env.VUE_APP_API_ENDPOINT+'read_rewardpoint',{ "details" :{}},this.auth1)
                  .then(response => {
                      console.log(response);
                      if(response.data.details){
                      let rewarddata=response.data.details[0];
                      axios
                        .post(process.env.VUE_APP_API_ENDPOINT+'credit_user_rewardpoint',querystring.stringify({ order_oid:this.ordermodal._id,credit:rewarddata.referral_point,r_credit:rewarddata.referee_point}),this.auth)
                        .then(response => {
                          
                        })

                    }
                        
                  })

             }
            }
            let _this=this;
            document.getElementById("updateproductbtn").innerHTML='...';
            document.getElementById("updateproductbtn").classList.remove('btn-primary');
            document.getElementById("updateproductbtn").classList.add('btn-success');
            document.getElementById("updateproductbtn").innerHTML='You order has been '+_this.ordermodal.order_status;
            setTimeout(function(){
            document.getElementById("updateproductbtn").classList.remove('btn-success');
            document.getElementById("updateproductbtn").classList.add('btn-primary');
            document.getElementById("updateproductbtn").innerHTML="Update";
            _this.editcategory=false;
            _this.getalldata();
          }, 2000);

            //window.location.reload()

          })
      },
      readyorder(order) {
        console.log(this.ordermodal);
           const querystring = require('querystring');
           swal({
            title: 'Are you sure?',
            text: "You want to process the order?",
            icon: 'info',
            buttons: {cancel: true,confirm: true,}
        }).then((result) => {
          if (result) {
           axios.post(process.env.VUE_APP_API_ENDPOINT+'update_order',querystring.stringify({ order_id : order.order_id,order_status:'ready',}),this.auth)
          .then(response => {
            console.log(response);
            let title='';
            let img='';
            let datetime= new Date();
            datetime=datetime.toString();
            let order_status_img='';
            if(this.ordermodal.order_status=='processing'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143645089922%20%281%29.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615449806078orderstatus_placed.png';
            }
            if(this.ordermodal.order_status=='shipped'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143644133501.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615626164310orderstatus_shipped.png';
            }
            if(this.ordermodal.order_status=='delivered'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143645588443.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615626069552orderstatus_delivered.png';
            }
            if(this.ordermodal.order_status=='cancelled'){
                img="https://captionplus.s3.ap-south-1.amazonaws.com/16143646488074%20%281%29.png";
                order_status_img='https://elfreshapp.s3.ap-south-1.amazonaws.com/1615627255989orderstatus_cancelled.png';
            }
            window.location.reload();

            //mail template
            let order_status=this.ordermodal.order_status;
            let name=this.ordermodal.user_oid.user_name;
            let order_no=this.ordermodal.order_no;
            let address=this.ordermodal.address;
            let city=this.ordermodal.city;
            let pincode=this.ordermodal.pincode;
            let state=this.ordermodal.state;  
            let orderdetails=this.ordermodal.order_items;
            let amount=this.ordermodal.amount/100;

            let message='<div style="width: 100%; height: 100%; margin: 10px auto; padding: 0; background-color: #f1f2f3; font-family: Roboto-Regular, Arial, Tahoma, Verdana, sans-serif; font-weight: 300; font-size: 13px; text-align: center;"> <div style="background: #4caf50; max-width: 680px; padding-top: 15px; margin: 0 auto; height: 45px;"> <div style="width: 50%; text-align: left; float: left; padding-left: 16px;"> <a style="text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="30" src="https://elfreshapp.s3.ap-south-1.amazonaws.com/1614757182990razorpay.png" alt="Elfresh.in" style="border: none;" class="CToWUd" /> </a> </div> <div style="text-align: right; color: rgba(255, 255, 255, 0.8); margin-top: 6px; font-family: Roboto-Medium, sans-serif; font-size: 14px; font-style: normal; font-stretch: normal; padding-right: 16px;"> Order '+order_status+' </div> </div> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 10px; background-color: #f1f2f3;"> <tbody> <tr> <td> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="display: block; margin: 0 auto; clear: both; padding: 0px 40px;"> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="color: #212121; display: block; margin: 0 auto; clear: both; padding: 3px 0 0 0;"> <table width="100%" cellspacing="0" cellpadding="0"> <tbody> <tr> <td valign="top" align="left" style="float: none; background-color: transparent; padding: 0; text-align: center; vertical-align: middle;"> <img border="0" src="'+order_status_img+'" alt="Order Jouney" style="border: none; width: 80%;" class="CToWUd" /> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 30px 0 0 0; max-width: 600px; background: #ffffff;" border="0"> <tbody> <tr> <td> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="table-layout: fixed; border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 260px; border: none; margin-bottom: 24px; margin-right: 30px;" > <tbody> <tr> <td valign="top" align="left" style="border-right: 1px solid #f4f4f4; padding-right: 10px;"> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121;margin-bottom: 5px;">Hi '+name+',</p> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121;">Order successfully '+order_status+'.</p> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;"></p> <p style="padding: 0; margin: 0; font-size: 12px; line-height: 20px; font-family: Roboto, sans-serif; font-weight: 400; padding-bottom: 12px;"> We are pleased to '+order_status+' your order no '+order_no+'. <br /> Thank you for shopping with El Fresh! </p> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 220px; border: none; margin-bottom: 24px;" > <tbody> <tr> <td valign="top" align="left"> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;">Delivery Address</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px; padding-right: 35px; color: #212121;"></p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+name+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+address+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+city+' - '+pincode+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+state+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">Mob. '+pincode+'</p> <p></p> </td> </tr> </tbody> </table> <table width="600" border="0" cellpadding="0" cellspacing="0" align="left"> <tbody> <tr> <td valign="top" align="left"> <p style=" font-family: Arial; font-size: 12px; text-align: left; color: #212121; padding-top: 0px; padding-bottom: 0px; line-height: 19px; margin-top: 0; margin-bottom: 0; " > <strong>Ordered Products</strong> </p> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="width: 100%; max-width: 600px; border-bottom: 1px solid #f0f0f0; background: #ffffff;" border="0"> <tbody> <tr></tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="color: #212121; display: block; margin: 0 auto; clear: both; padding: 30px 0 24px 0;"> <table width="100%" cellspacing="0" cellpadding="0"> <tbody>';
            for (let i = 0; i < orderdetails.length; i++) {  

              message +='<tr> <td width="120" valign="top" align="left"> <a style="color: #027cd8; text-decoration: none; outline: none; color: #ffffff; font-size: 13px; display: block; width: 100px;" href="#" target="_blank" > <img border="0" src="'+orderdetails[i].products.item_thumbnail+'" alt="'+orderdetails[i].products.item_name+'" style="border: none; margin-left: auto; margin-right: auto; display: block; width: fit-content;max-width: 100px;" class="CToWUd" /> </a> </td> <td valign="top" align="left"> <p style="margin-bottom: 13px;"> <a href="#" style=" font-family: Roboto, sans-serif; font-size: 14px; font-weight: normal; font-style: normal; font-stretch: normal; line-height: 1.25; color: #2175ff; text-decoration: none; " target="_blank" > '+orderdetails[i].item_price_type.quantity+' '+orderdetails[i].item_price_type.unit+' </a> <sup></sup> <br /> </p> <p style=" font-family: Roboto, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; line-height: 1.5; font-stretch: normal; color: #212121; margin: 0px 0px; " > '+orderdetails[i].products.item_name+' </p> <p style="font-family: Roboto-Medium, sans-serif; font-style: normal; line-height: 1.5; font-stretch: normal; color: #212121; margin: 5px 0px;"> <span style="padding-right: 10px;">₹'+orderdetails[i].item_price_type.price+'</span> <span style=" font-family: Roboto-Medium, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; line-height: 1.5; font-stretch: normal; color: #878787; margin: 0px 0px; border: 1px solid #dfdfdf; display: inline; border-radius: 3px; padding: 3px 10px; " > Qty: '+orderdetails[i].product_qty+'</span></p></td></tr>';

            }

            message+='</tbody> </table> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 30px 0 0 0; max-width: 600px; background: #ffffff;" border="0"> <tbody> <tr> <td> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 220px; border: none; margin-bottom: 24px;" > <tbody> <tr> <td valign="top" align="left"> <p style="padding: 0; margin: 0; font-size: 14px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;">Payment Details</p> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td style="padding: 0px;"> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; font-weight: 400; color: #212121;"> Amount Payable <span style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto-Medium, sans-serif; color: #212121; padding-left: 10px;">₹'+amount+'</span> </p> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <br /> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; margin-top: 24px;"> <tbody> <tr> <td align="left" valign="top" style="color: #2c2c2c; display: block; line-height: 20px; font-weight: 300; margin: 0 auto; clear: both; background-color: transparent;"> <table class="m_-5815304530935329508body-wrapper"> <tbody> <tr> <td style="width: 75%; text-align: left;"> <a style="color: #027cd8; text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="50" src="https://elfreshapp.s3.ap-south-1.amazonaws.com/1614757182990razorpay.png" alt="Flipkart.com" style="border: none;" class="CToWUd" /> </a> </td> <td style="width: 8%; text-align: left;"> <a style="text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="24" src="https://ci6.googleusercontent.com/proxy/3QE9kvI6a_sNZY1yz9h1e9UTtBEe6bvUPfsokYVFhigLrmrCJxcv1_CZk0b5cJWyTHa1prcEfHSGUl1QMcg36fPaTs0H7MVxDk0pgC8ujoEedjfg26Rdff_eNArN9_s=s0-d-e1-ft#http://img6a.flixcart.com/www/promos/new/20160910-183744-google-play-min.png" alt="Flipkart.com" style="border: none;" class="CToWUd" /> </a> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <img style="width: 1px; height: 1px;" src="https://ci5.googleusercontent.com/proxy/of2aZ7knL5CxEa8F8aZ46X08Ng9atQwmyw1vsqbopYypXklKaz-rQnALOE9fy0bP3GYh1nygy9zPHpIHAZYdsbAle2ql9EyZfx6yMA4IltKvDStbNs0P6B7YFcAsEGjoLZb3Yl7Js4v-HW4bUkBRvFBktvO-Q9CKdmzv_AoPGYfxPaRnXn405GX1gMVhNxg7_OubIWrdkr0Ct7OjbR8vcpnkk9spzA_ULIk7OOuYvNov7Jp9XHwLsHqM7BYcUD4HADPCAfPHxPqDj1oYZG4IOl2sR6yrsY9PihpwZzDe3jhQ-mIVlp5awBwLi_KO99hOt0imjghl9QNL=s0-d-e1-ft#http://l.flipkart.com/t/open/H4sIAAAAAAAAAB2MzQ7CIBCE32XPpWEV-enJi0efwSwULLFNGwKmxvjurt5m5vsyb3jCgB0EGCAulGfoIHPW-mjiwaFwyqBQzgVhk5LCS-nRhpNPLrI6srpQKy_qC01tRsTz_XfTh3VhHioLJVKY1lb_fefhchW17DeyRkqdDLkxeobEKM15e1Cp8PkCqJhVxpoAAAA=" class="CToWUd" /> <div class="yj6qo"></div> <div class="adL"></div> </div>';

            axios.post(process.env.VUE_APP_API_ENDPOINT+'create_notification',querystring.stringify({user_oid:this.ordermodal.user_oid._id,notif_todo : 'openOrderDetails',notif_title:'You order has been '+this.ordermodal.order_status,notif_message:'View order details',notif_img:img,notif_link:this.ordermodal._id,created_by:localStorage.getItem('_id'),notif_date:datetime}),this.auth)
              .then(response => {
            
              // console.log(response);
                        axios
                           .post(process.env.VUE_APP_API_ENDPOINT+'push_notification',querystring.stringify({ fcm_token:this.ordermodal.user_oid.user_fcm,notif_todo:'openOrderDetails',notif_title:'You order has been '+this.ordermodal.order_status,notif_message:'View order details',notif_img:img,notif_thumbnail:img,notif_link:this.ordermodal._id,sender_id:'Admin',notification_id:response.data.details.notification_id}),this.auth)
                          .then(response => {

                            // console.log(response);
                            
                            
                          })
              
              
            })
            axios
             .post(process.env.VUE_APP_API_ENDPOINT+'send_mail',querystring.stringify({ email:this.ordermodal.user_oid.user_email,user_name:this.ordermodal.user_oid.user_name,subject_body:'You order status updated',type:'orderupdate',html_body:message}),this.auth)
            .then(response => {

              // console.log(response);
              
              
            })
            if(this.ordermodal.order_status=='delivered'){
             console.log(this.ordermodal);
             if(this.ordermodal.user_oid.redemption_done=='no' && this.ordermodal.user_oid.refer_by_code!=undefined){
               axios
                  .post(process.env.VUE_APP_API_ENDPOINT+'read_rewardpoint',{ "details" :{}},this.auth1)
                  .then(response => {
                      console.log(response);
                      if(response.data.details){
                      let rewarddata=response.data.details[0];
                      axios
                        .post(process.env.VUE_APP_API_ENDPOINT+'credit_user_rewardpoint',querystring.stringify({ order_oid:this.ordermodal._id,credit:rewarddata.referral_point,r_credit:rewarddata.referee_point}),this.auth)
                        .then(response => {
                          
                        })

                    }
                        
                  })

             }
            }
            let _this=this;
            document.getElementById("updateproductbtn").innerHTML='...';
            document.getElementById("updateproductbtn").classList.remove('btn-primary');
            document.getElementById("updateproductbtn").classList.add('btn-success');
            document.getElementById("updateproductbtn").innerHTML='You order has been '+_this.ordermodal.order_status;
            setTimeout(function(){
            document.getElementById("updateproductbtn").classList.remove('btn-success');
            document.getElementById("updateproductbtn").classList.add('btn-primary');
            document.getElementById("updateproductbtn").innerHTML="Update";
            _this.editcategory=false;
            _this.getalldata();
            }, 2000);

            window.location.reload()
            })
          }
        });
      },
      deleteorder(row) {
        console.log(row);
        const querystring = require('querystring');
          swal({
              title: 'Are you sure?',
              text: "wan't to delete",
              icon: 'warning',
              buttons: {cancel: true,confirm: true,}
          }).then((result) => { // <--
            if (result) {
              console.log('result cloud',result)
              axios.post(process.env.VUE_APP_API_ENDPOINT+'delete_order',querystring.stringify({order_id :row.order_id,order_oid:row._id}),this.auth)
            .then(response => {
                let _this=this;
                console.log(response);
                swal({
                  title:'Deleted!',
                  text: 'Your order has been deleted.',
                  icon:'success',
                 }).then((result) => {
                  console.log(result)
                  _this.getalldata();
                })
              })
             }
          });
      },
      format_datetime(value){
           if(value) {
             return moment.utc(new Date(value)).format("LLL")
            }
      },
      previouspage(){
      const querystring = require('querystring');
      //console.log(this.auth);
      if(this.offset>0){
      --this.offset;
      let details={ "details" :{"type":"order"},"offset":this.offset.toString()};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                  details.details.store_id=localStorage.getItem('store_id');
        }
     axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
      .then(response => {
        //console.log(response);
        if(response.data.details){
        this.datanotfound=false;
        this.orderData=response.data.details;
        }else{
          this.orderData=[];
          this.datanotfound=true;
        }
            
      })
    }
    },
    gotopage(){
      const querystring = require('querystring');
      //console.log(this.auth);
      if(document.getElementById("page_no").value){
      this.offset=document.getElementById("page_no").value;
      let details={ "details" :{"type":"order"},"offset":this.offset.toString()};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                  details.details.store_id=localStorage.getItem('store_id');
        }
     axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
      .then(response => {
        //console.log(response);
        if(response.data.details){
        this.orderData=response.data.details;
        this.datanotfound=false;
        }else{
          this.orderData=[];
          this.datanotfound=true;
        }
            
      })

      }

    },
    nextpage(){
        this.offset=this.offset+1;
        const querystring = require('querystring');
        let details={ "details" :{"type":"order"},"offset":this.offset.toString()};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                  details.details.store_id=localStorage.getItem('store_id');
        }
        //console.log(this.auth);
        axios
          .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
          .then(response => {
            //console.log(response);
            if(response.data.details){
            this.orderData=response.data.details;
            this.datanotfound=false;
            }else{
              this.offset=this.offset-1;
              this.orderData=[];
              this.datanotfound=true;
            }
                
          })

     },
    },
  };
</script>
<style>
  .search-input .form-group {
    display: inline-block;
    margin-bottom: 0px;
  }
</style>
